/* ============================================================
   ATHLO+ — Coach Portal (ADDON, Phase 2, 2026-11-04)
   Mount: [data-coach-portal] in sections/hub-coach-portal.liquid. Backend: the `coaching`
   edge function. The link the coach is sent (?t=c1.<slug>.<epoch>.<sig>) IS the credential;
   it is kept in localStorage so /pages/coach keeps working from a home-screen bookmark.

   Screens: home (athletes, needs-action first) -> one athlete (Plan / Chat / About).
   Every string from the server goes through textContent or esc(); nothing is innerHTML'd raw.
   ============================================================ */
(function () {
  'use strict';
  var mount = document.querySelector('[data-coach-portal]');
  if (!mount) return;
  var cfgEl = mount.querySelector('[data-coach-config]');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }
  var EP = (CFG.endpoint || '').replace(/\/$/, '');
  var TZ = 'Asia/Singapore';
  var KEY = 'athlo:coach-token';

  var qs = new URLSearchParams(location.search);
  var TOKEN = qs.get('t') || '';
  try {
    if (TOKEN) localStorage.setItem(KEY, TOKEN);
    else TOKEN = localStorage.getItem(KEY) || '';
  } catch (e) { /* private mode: the URL token still works */ }

  var state = { home: null, current: null, tab: 'plan', weekStart: null, planView: 'week', monthStart: null, paste: null };

  // ---------- helpers ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function api(method, params, body) {
    var url = EP + (params ? '?' + new URLSearchParams(params).toString() : '');
    return fetch(url, {
      method: method,
      headers: { 'content-type': 'application/json', 'x-coach-token': TOKEN },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return { ok: false, error: 'bad_response' }; }).then(function (j) {
        j._status = r.status; return j;
      });
    }).catch(function () { return { ok: false, error: 'offline' }; });
  }
  function post(body) { return api('POST', null, body); }

  function addDays(day, n) { var d = new Date(day + 'T00:00:00Z'); d.setUTCDate(d.getUTCDate() + n); return d.toISOString().slice(0, 10); }
  function mondayOf(day) { var d = new Date(day + 'T00:00:00Z'); return addDays(day, -((d.getUTCDay() + 6) % 7)); }
  function fmtDay(day, opts) {
    return new Date(day + 'T00:00:00Z').toLocaleDateString('en-SG', Object.assign({ timeZone: 'UTC' }, opts || { weekday: 'short', day: 'numeric', month: 'short' }));
  }
  function fmtWhen(iso) {
    return new Date(iso).toLocaleString('en-SG', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' });
  }
  function ago(iso) {
    var s = (Date.now() - Date.parse(iso)) / 1000;
    if (s < 90) return 'just now';
    if (s < 3600) return Math.round(s / 60) + ' min ago';
    if (s < 86400) return Math.round(s / 3600) + ' h ago';
    return fmtWhen(iso);
  }
  function initials(n) { return String(n || '?').trim().split(/\s+/).slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase(); }
  function toast(msg, long) {
    var t = document.createElement('div'); t.className = 'co__toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, long ? 5000 : 2200);
  }
  // ---------- files: photos, screenshots, watch files (2026-11-04) ----------
  var ACCEPT = 'image/*,.gpx,.tcx,.fit';
  /** Photos are shrunk on the phone before upload (max 1600 px JPEG). That also drops the photo's location data. */
  function prepFile(f) {
    if (!/^image\/(jpeg|png|webp)$/i.test(f.type) || !window.createImageBitmap) return Promise.resolve(f);
    return createImageBitmap(f).then(function (bmp) {
      var k = Math.min(1, 1600 / Math.max(bmp.width, bmp.height));
      var c = document.createElement('canvas'); c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
      c.getContext('2d').drawImage(bmp, 0, 0, c.width, c.height);
      return new Promise(function (res) {
        c.toBlob(function (b) { res(b ? new File([b], f.name.replace(/\.[a-z0-9]+$/i, '') + '.jpg', { type: 'image/jpeg' }) : f); }, 'image/jpeg', 0.85);
      });
    }).catch(function () { return f; });
  }
  /** Upload each file to its signed slot; resolves to the [{path,name}] list the next call attaches. */
  function uploadAll(list) {
    var out = [];
    return list.reduce(function (p, f) {
      return p.then(function (r) {
        if (r && r.error) return r;
        return prepFile(f).then(function (g) {
          return post({ action: 'coach-upload-url', enrolment_id: state.current.athlete.id, name: g.name, bytes: g.size }).then(function (slot) {
            if (!slot.ok) return { error: slot.error || 'upload_failed' };
            var fd = new FormData(); fd.append('cacheControl', '3600'); fd.append('', g);
            return fetch(slot.signed_url, { method: 'PUT', body: fd, headers: { 'x-upsert': 'false' } }).then(function (res) {
              if (!res.ok) return { error: 'upload_failed' };
              out.push({ path: slot.path, name: f.name });
            }, function () { return { error: 'upload_failed' }; });
          });
        });
      });
    }, Promise.resolve(null)).then(function (r) { return r && r.error ? r : { files: out }; });
  }
  function fmtDur(sec) {
    if (!sec && sec !== 0) return '';
    var h = Math.floor(sec / 3600), m = Math.floor(sec % 3600 / 60), x = sec % 60;
    return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(x).padStart(2, '0');
  }
  function filesHtml(list) {
    if (!list || !list.length) return '';
    return '<div class="co__files">' + list.map(function (a) {
      if (a.kind === 'image' && a.url && !/heic|heif/.test(a.mime)) {
        return '<a class="co__thumb" href="' + esc(a.url) + '" target="_blank" rel="noopener"><img src="' + esc(a.url) + '" alt="' + esc(a.name || 'Photo') + '" loading="lazy"></a>';
      }
      var sum = a.summary || {}, bits = [];
      if (sum.distance_km) bits.push(sum.distance_km + ' km');
      if (sum.duration_s) bits.push(fmtDur(sum.duration_s));
      var label = a.kind === 'track' ? (bits.length ? 'Route · ' + bits.join(' · ') : 'Watch file') : 'Photo';
      return '<a class="co__file" href="' + esc(a.url || '#') + '" target="_blank" rel="noopener" download>' + esc(label) +
        ' <small>' + esc((a.name || '').split('.').pop().toUpperCase()) + '</small></a>';
    }).join('') + '</div>';
  }
  function filePicker() {
    return '<label class="co__attach"><input type="file" class="co__file-input" multiple accept="' + ACCEPT + '" data-files>' +
      '<span class="co__btn co__btn--sm co__btn--ghost">+ Photo or watch file</span><span class="co__attach-list" data-file-list aria-live="polite"></span></label>';
  }
  function bindPicker(root) {
    var inp = root.querySelector('[data-files]'), list = root.querySelector('[data-file-list]');
    if (!inp) return function () { return []; };
    inp.addEventListener('change', function () {
      var n = inp.files.length;
      list.textContent = n ? n + ' file' + (n > 1 ? 's' : '') + ': ' + [].map.call(inp.files, function (f) { return f.name; }).join(', ') : '';
    });
    return function () { return [].slice.call(inp.files || []); };
  }

  var ERR = {
    offline: 'No connection. Check your signal and try again.',
    rate_limited: 'Too many changes at once. Wait a few seconds and try again.',
    closed: 'This athlete\'s coaching has ended, so it can no longer be changed.',
    already_started: 'They have already started training.',
    not_found: 'That athlete or session is no longer there. Go back and open them again.',
    save_failed: 'That did not save. Try again.',
    server_error: 'Something went wrong on our side. Try again in a minute.',
    bad_day: 'Pick a date from the calendar.',
    plan_empty: 'Add at least one session before sending the plan.',
    next_week_not_empty: 'Next week already has sessions.',
    week_empty: 'There is nothing in this week to copy.',
    slot_in_past: 'One of those times has already passed (or is within 30 minutes).',
    slot_too_far: 'Offer times within the next 60 days.',
    slots_1_to_5: 'Offer between one and five times.',
    missing_title: 'Give the session a name, e.g. "Easy run".',
    plan_too_long: 'That would make the plan longer than 400 sessions. Paste fewer rows, or choose Replace.',
    nothing_to_import: 'Nothing to add: no row had a date and a session.',
    bad_text: 'That paste is too large. Paste one month or a few weeks at a time.',
    bad_type: 'Only photos (JPG, PNG, HEIC) and watch files (GPX, TCX, FIT) can be attached.',
    too_big: 'Each file can be up to 10 MB.',
    too_many_files: 'Up to 4 files at a time.',
    file_not_uploaded: 'A file did not finish uploading. Try again.',
    upload_failed: 'A file did not finish uploading. Try again.',
    upload_unavailable: 'Uploads are not available right now. Try again in a moment.',
    empty_review: 'Pick a verdict or a focus, or write something.',
    focus_max_3: 'Pick up to three focus areas.',
    telegram_off: 'Telegram alerts are not switched on yet.'
  };
  function errText(j) { return ERR[j && j.error] || 'Something went wrong. Try again in a moment.'; }

  var STEP = {
    choose_start: { t: 'New, waiting for them to start', c: '' },
    intake: { t: 'Answering your questions', c: '' },
    awaiting_slots: { t: 'Wants a call: offer times', c: 'warn', act: true },
    pick_slot: { t: 'Times offered, waiting for them', c: '' },
    awaiting_plan: { t: 'Ready: write their plan', c: 'warn', act: true },
    training: { t: 'Training', c: 'go' },
    ended: { t: 'Ended', c: '' },
    cancelled: { t: 'Cancelled', c: '' }
  };

  // ---------- screens ----------
  // keepScroll: a save that redraws the same screen stays where the coach was working (Phase 7).
  function render(html, keepScroll) { var y = window.scrollY; mount.innerHTML = html; window.scrollTo(0, keepScroll ? y : 0); }

  function noLink(replaced) {
    render('<div class="co__card"><p class="co__label">ATHLO+ coaches</p><h1 class="co__h">' + (replaced ? 'This link no longer works' : 'Open your coach link') + '</h1>' +
      '<p class="co__p">' + (replaced
        ? 'Your portal link was replaced with a new one, or this is an old copy of it.'
        : 'This page opens from the private link we sent you.') + ' Enter the e-mail address we have for you and we will send your link straight away.</p>' +
      '<form data-relink novalidate><label class="co__field"><span>Your e-mail</span><input class="co__input" type="email" name="email" autocomplete="email" required placeholder="name@example.com"></label>' +
      '<button class="co__btn co__btn--primary co__btn--block" type="submit">Send me my link</button><p class="co__err" hidden></p></form>' +
      (CFG.helpEmail ? '<p class="co__p co__small" style="margin-top:.8rem">Still stuck? E-mail <a href="mailto:' + esc(CFG.helpEmail) + '">' + esc(CFG.helpEmail) + '</a>.</p>' : '') +
      '</div>');
    var f = mount.querySelector('[data-relink]');
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var er = f.querySelector('.co__err'), btn = f.querySelector('[type=submit]');
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(f.email.value.trim())) { er.textContent = 'That does not look like an e-mail address.'; er.hidden = false; return; }
      btn.disabled = true;
      post({ action: 'portal-link-request', email: f.email.value.trim() }).then(function (r) {
        btn.disabled = false;
        if (!r.ok) { er.textContent = errText(r); er.hidden = false; return; }
        f.innerHTML = '<p class="co__p"><b>Check your inbox.</b> If that address is the one we have for you, your link is on its way. Open it on this phone, in your normal browser, to stay signed in.</p>';
      });
    });
  }

  function loading() { render('<div class="co__skel" aria-label="Loading"></div>'); }

  function loadHome() {
    if (!TOKEN || !EP) return noLink();
    loading();
    api('GET', { action: 'coach-home' }).then(function (j) {
      if (j._status === 401) { try { localStorage.removeItem(KEY); } catch (e) { /* */ } return noLink(true); }
      if (!j.ok) {
        render('<div class="co__card"><p class="co__err">' + esc(errText(j)) + '</p><button class="co__btn co__btn--primary" type="button" data-retry>Try again</button></div>');
        return mount.querySelector('[data-retry]').addEventListener('click', loadHome);
      }
      state.home = j; state.current = null; drawHome();
    });
  }

  function drawHome() {
    var j = state.home;
    var list = j.athletes.slice().sort(function (a, b) {
      var aa = (a.overdue ? 8 : 0) + (a.risk ? 4 : 0) + (STEP[a.step] && STEP[a.step].act ? 2 : 0) + (a.unread || a.to_review ? 1 : 0);
      var bb = (b.overdue ? 8 : 0) + (b.risk ? 4 : 0) + (STEP[b.step] && STEP[b.step].act ? 2 : 0) + (b.unread || b.to_review ? 1 : 0);
      return bb - aa || String(b.last_activity).localeCompare(String(a.last_activity));
    });
    var active = list.filter(function (a) { return a.status !== 'ended' && a.status !== 'cancelled'; });
    var past = list.filter(function (a) { return a.status === 'ended' || a.status === 'cancelled'; });
    var todo = active.filter(function (a) { return (STEP[a.step] && STEP[a.step].act) || a.unread || a.to_review || a.overdue; }).length;

    var h = '<div class="co__card"><p class="co__label">Coach portal</p>' +
      '<h1 class="co__h">Hi ' + esc(String(j.coach.name).split(' ')[0]) + '</h1>' +
      '<p class="co__p">' + (active.length
        ? '<b>' + active.length + '</b> athlete' + (active.length > 1 ? 's' : '') + ' with you' + (todo ? ', <b>' + todo + '</b> need' + (todo > 1 ? '' : 's') + ' you now.' : '. All caught up.')
        : 'No athletes yet. When someone buys coaching with you, they appear here and you get an e-mail.') + '</p>' +
      (j.coach.has_email ? '' : '<p class="co__p co__small">We do not have your e-mail yet, so you will not get notifications. Reply to our message with the address you want to use.</p>') +
      '</div>';
    if (active.length) h += '<div class="co__card"><ul class="co__list">' + active.map(athleteRow).join('') + '</ul></div>';
    if (past.length) h += '<div class="co__card"><p class="co__label">Past athletes</p><ul class="co__list">' + past.map(athleteRow).join('') + '</ul></div>';
    h += shareCard(j.coach) + alertsCard(j.alerts) + guideCard(active.length);
    render(h);
    var sk = mount.querySelector('[data-share-kit]'); if (sk) sk.addEventListener('click', function () { openShareKit(j.coach); });
    bindAlerts();
    mount.querySelectorAll('[data-open]').forEach(function (b) {
      b.addEventListener('click', function () { openAthlete(b.getAttribute('data-open')); });
    });
  }

  function athleteRow(a) {
    var st = STEP[a.step] || { t: a.step, c: '' };
    var sub = a.step === 'cancelled' && a.cancel_reason === 'refunded' ? 'Refunded' : st.t;
    if (a.step === 'training' && a.ends_on) sub += ' · until ' + fmtDay(a.ends_on, { day: 'numeric', month: 'short' });
    if (a.step === 'training' && a.planned_until) sub += ' · planned to ' + fmtDay(a.planned_until, { day: 'numeric', month: 'short' });
    return '<li><button type="button" class="co__athlete" data-open="' + esc(a.id) + '">' +
      '<span class="co__mono" aria-hidden="true">' + esc(initials(a.name)) + '</span>' +
      '<span class="co__athlete-main"><span class="co__athlete-name">' + esc(a.name) + (a.founding ? ' <span class="co__founding co__founding--sm">Founding</span>' : '') + '</span>' +
      (a.overdue ? '<span class="co__athlete-sub"><span class="co__chip co__chip--late">Overdue · waiting ' + lateText(a.overdue.hours) + '</span></span>' : '') +
      (a.risk ? '<span class="co__athlete-sub"><span class="co__chip co__chip--warn">' + esc(riskText(a.risk)) + '</span></span>' : '') +
      (a.pct !== undefined && a.pct !== null ? '<span class="co__athlete-sub">Block ' + a.pct + '% done</span>' : '') +
      '<span class="co__athlete-sub">' + (st.c ? '<span class="co__chip co__chip--' + st.c + '">' + esc(sub) + '</span>' : esc(sub)) + '</span>' +
      (a.week && a.week.planned ? '<span class="co__athlete-sub">This week ' + a.week.done + ' of ' + a.week.due + ' done' +
        (a.week.missed ? ' · <span class="co__miss">' + a.week.missed + ' missed</span>' : '') + '</span>' : '') +
      (a.to_review ? '<span class="co__athlete-sub"><span class="co__chip co__chip--warn">' + a.to_review + ' to review</span></span>' : '') + '</span>' +
      (a.unread ? '<span class="co__badge" aria-label="' + a.unread + ' new">' + a.unread + '</span>' : '') +
      '</button></li>';
  }

  // The coach's how-to (2026-11-04): open by default until they have an athlete, then folded away.
  function guideCard(n) {
    var steps = [
      ['Someone books you', 'You get an e-mail and they appear in the list above. Open them to see their order and, once they fill it in, their intake.'],
      ['They answer your questions first', 'Everyone fills in a 5-minute intake (goal, current training, days, injuries). You get the answers by e-mail and in About. If they also want an intro call, you offer up to three times in the Intro call tab once the answers are in; they pick one and leave their number, and the booking e-mail and a reminder the day before carry their answers again.'],
      ['Write the plan', 'Plan tab: press + Add on a day for each session. To plan a month at once, paste it from Excel or Google Sheets.'],
      ['Send it', 'Nothing is visible to them until you press Send plan. Their month starts the day you send it. After that, every change shows straight away; Send update also e-mails them.'],
      ['Review their sessions', 'Logs + chat: each logged session shows their result, effort and notes, plus any photo or watch file. Review gives a verdict and up to three focus areas, with an optional note. Missed sessions are counted for you at the top.'],
      ['Stay in touch', 'Messages are in Logs + chat. Turn on Telegram alerts on this screen for an instant ping; otherwise you get at most one e-mail every 3 hours per athlete.']
    ];
    return '<details class="co__card co__guide"' + (n ? '' : ' open') + '><summary class="co__guide-sum">How the portal works</summary><ol class="co__guide-list">' +
      steps.map(function (x) { return '<li><b>' + esc(x[0]) + '.</b> ' + esc(x[1]) + '</li>'; }).join('') +
      '</ol><p class="co__small">Keep your portal link private: anyone with it can open your portal. If it gets out, tell us and we will send you a new one.</p></details>';
  }
  function alertsCard(al) {
    var t = al && al.telegram;
    if (!t || !t.available) return '';
    return '<div class="co__card"><p class="co__label">Alerts</p>' + (t.linked
      ? '<p class="co__p">Telegram alerts are <b>on</b>: every log, message and booking arrives there straight away.</p><button class="co__btn co__btn--sm" data-tg="off">Turn Telegram alerts off</button>'
      : '<p class="co__p">E-mail tells you when something is new. For an instant ping, connect Telegram once.</p><button class="co__btn co__btn--primary" data-tg="on">Get alerts on Telegram</button>') + '</div>';
  }
  function bindAlerts() {
    var b = mount.querySelector('[data-tg]');
    if (!b) return;
    b.addEventListener('click', function () {
      var on = b.getAttribute('data-tg') === 'on';
      var w = on ? window.open('', '_blank') : null;
      b.disabled = true;
      post({ action: on ? 'coach-tg-link' : 'coach-tg-unlink' }).then(function (r) {
        b.disabled = false;
        if (!r.ok) { if (w) w.close(); return toast(errText(r), true); }
        if (on) { if (w) w.location = r.url; else location.href = r.url; toast('Tap Start in Telegram to finish'); }
        else { toast('Telegram alerts off'); loadHome(); }
      });
    });
  }

  function openAthlete(id, keepTab) {
    if (!keepTab) loading();
    api('GET', { action: 'coach-athlete', id: id }).then(function (j) {
      if (j._status === 401) return noLink(true);
      if (!j.ok) return render('<div class="co__card"><p class="co__err">' + esc(errText(j)) + '</p><button class="co__btn" data-back>Back</button></div>'), bindBack();
      state.current = j; state.keepScroll = !!keepTab;
      if (!keepTab) {
        state.planView = 'week'; state.paste = null;
        state.tab = j.athlete.step === 'training' ? (j.athlete.unread ? 'chat' : 'plan') : (j.athlete.step === 'awaiting_slots' ? 'call' : 'plan');
        var firstPlanned = j.sessions.length ? j.sessions[0].day : null;
        state.weekStart = mondayOf(j.today > (firstPlanned || j.today) && j.athlete.step === 'training' ? j.today : (firstPlanned || j.today));
      }
      drawAthlete();
    });
  }
  function refresh() { return openAthlete(state.current.athlete.id, true); }
  function bindBack() {
    mount.querySelectorAll('[data-back]').forEach(function (b) { b.addEventListener('click', loadHome); });
  }

  function drawAthlete() {
    var j = state.current, a = j.athlete;
    var st = STEP[a.step] || { t: a.step };
    var tabs = [['plan', 'Plan'], ['chat', 'Logs + chat' + (a.unread ? ' (' + a.unread + ')' : '')], ['progress', 'Progress'], ['about', 'About']];
    if (a.start_mode === 'call' || a.call_slots.length) tabs.splice(2, 0, ['call', 'Intro call']);
    var h = '<button type="button" class="co__btn co__btn--ghost co__btn--sm" data-back>&larr; All athletes</button>' +
      '<div class="co__card" style="margin-top:.6rem"><div class="co__row co__row--between">' +
      '<div><p class="co__label">' + esc(a.order_name || '') + ' · ' + a.months + ' month' + (a.months > 1 ? 's' : '') + '</p>' +
      '<h1 class="co__h">' + esc(a.name) + '</h1>' + (a.founding ? '<p class="co__founding" title="Signed up on launch day">Founding Athlete</p>' : '') + '</div></div>' +
      '<p class="co__p">' + esc(st.t) + (a.starts_on ? ' · ' + fmtDay(a.starts_on, { day: 'numeric', month: 'short' }) + ' to ' + fmtDay(a.ends_on, { day: 'numeric', month: 'short' }) : '') + '</p>' +
      progressHtml(j.progress) + banner(a) + '</div>' +
      '<div class="co__tabs" role="tablist">' + tabs.map(function (t) {
        return '<button type="button" class="co__tab" role="tab" aria-selected="' + (state.tab === t[0]) + '" data-tab="' + t[0] + '">' + esc(t[1]) + '</button>';
      }).join('') + '</div><div data-pane></div>';
    render(h, state.keepScroll); state.keepScroll = false;
    bindBack();
    mount.querySelectorAll('[data-tab]').forEach(function (b) {
      b.addEventListener('click', function () { state.tab = b.getAttribute('data-tab'); drawAthlete(); });
    });
    mount.querySelectorAll('[data-goto]').forEach(function (b) {
      b.addEventListener('click', function () { state.tab = b.getAttribute('data-goto'); drawAthlete(); });
    });
    var pane = mount.querySelector('[data-pane]');
    if (state.tab === 'plan') { if (state.paste) drawPaste(pane); else drawPlan(pane); }
    else if (state.tab === 'chat') drawChat(pane);
    else if (state.tab === 'call') drawCall(pane);
    else if (state.tab === 'progress') drawProgress(pane);
    else drawAbout(pane);
  }

  function progressHtml(p) {
    if (!p || !p.week) return '';
    var w = p.week, b = p.block, h = '<div class="co__progress">';
    h += '<span><b>This week</b> ' + w.done + ' of ' + w.due + ' done' + (w.ahead ? ', ' + w.ahead + ' to come' : '') + '</span>';
    if (b && b.due) h += '<span><b>Block so far</b> ' + b.done + ' of ' + b.due + ' (' + Math.round(100 * b.done / b.due) + '%)</span>';
    if (p.to_review) h += '<span class="co__chip co__chip--warn">' + p.to_review + ' log' + (p.to_review > 1 ? 's' : '') + ' to review</span>';
    h += '</div>';
    if (w.missedList.length) h += '<p class="co__small co__miss">Missed: ' + w.missedList.map(function (m) {
      return esc(fmtDay(m.day, { weekday: 'short' }) + ' ' + m.title); }).join(', ') + '</p>';
    return h;
  }

  // ── Phase 6 (2026-11-05): the coach's share kit ─────────────────────────────────────────────────
  // A branded 1080x1350 card drawn on a canvas (brand fonts, no generated imagery, no photo needed) and a
  // caption in plain words with their link. Coaches' own followers are where sign-ups come from.
  function shareCard(c) {
    if (!c || !c.product_url) return '';
    return '<div class="co__card"><p class="co__label">Tell your followers</p>' +
      '<p class="co__p">An Instagram-ready image and caption with your coaching link' + (c.product_status === 'active' ? '' : ' (your page goes live when ATHLO+ opens coaching)') + '.</p>' +
      '<button class="co__btn co__btn--block" data-share-kit>Open my share kit</button></div>';
  }
  function shareCaption(c) {
    var first = String(c.name || '').split(' ')[0];
    var price = c.price ? 'S$' + String(Number(c.price)).replace(/\.0+$/, '') + ' a month' : 'monthly';
    return 'I am coaching on ATHLO+.\n\n' +
      'You get a plan written for you, week by week, around the days you actually have. Log each session and I reply with feedback on it.\n\n' +
      'Start with a 5-minute intake, plus a short intro call if you want one. ' + price + (c.spots_left != null ? ', and I am only taking ' + c.spots_left + ' athlete' + (c.spots_left === 1 ? '' : 's') + ' for now' : '') + '.\n\n' +
      'Link: ' + c.product_url + '\n\n#athlosg #coachedby' + first.toLowerCase();
  }
  function drawShareImage(canvas, c) {
    var g = canvas.getContext('2d'), W = 1080, H = 1350;
    var css = getComputedStyle(document.documentElement);
    var disp = (css.getPropertyValue('--font-display') || '').trim() || 'Impact, sans-serif';
    var body = (css.getPropertyValue('--font-body') || '').trim() || 'Helvetica, Arial, sans-serif';
    g.fillStyle = '#0B0E12'; g.fillRect(0, 0, W, H);
    var grad = g.createRadialGradient(W * 0.8, H * 0.15, 40, W * 0.8, H * 0.15, 760);
    grad.addColorStop(0, 'rgba(183,255,0,0.22)'); grad.addColorStop(1, 'rgba(183,255,0,0)');
    g.fillStyle = grad; g.fillRect(0, 0, W, H);
    g.fillStyle = '#B7FF00'; g.font = '700 34px ' + body; g.fillText('ATHLO+ COACHING', 90, 150);
    var parts = String(c.name || 'Your coach').toUpperCase().split(' ');
    g.fillStyle = '#FFFFFF'; g.font = '400 92px ' + disp; g.fillText('COACH WITH', 90, 330);
    g.font = '400 190px ' + disp;
    var y = 520; parts.slice(0, 2).forEach(function (w) { g.fillText(w, 90, y); y += 185; });
    g.fillStyle = '#EFEFEF'; g.font = '400 40px ' + body;
    ['A plan written for you, week by week.', 'Feedback on every session you log.'].forEach(function (t, i) { g.fillText(t, 90, 960 + i * 58); });
    g.fillStyle = '#B7FF00'; g.fillRect(90, 1110, 900, 4);
    g.font = '700 46px ' + body;
    var price = c.price ? 'S$' + String(Number(c.price)).replace(/\.0+$/, '') + ' / month' : '';
    g.fillText(price + (c.spots_left != null ? (price ? '   ·   ' : '') + c.spots_left + ' spot' + (c.spots_left === 1 ? '' : 's') : ''), 90, 1190);
    g.fillStyle = '#A7AFB8'; g.font = '400 34px ' + body; g.fillText('athlo.sg  ·  link in bio', 90, 1262);
  }
  function openShareKit(c) {
    var h = '<button type="button" class="co__btn co__btn--ghost co__btn--sm" data-back>&larr; Back</button>' +
      '<div class="co__card" style="margin-top:.6rem"><p class="co__label">Your share kit</p>' +
      '<canvas class="co__share" width="1080" height="1350" aria-label="Your coaching post image"></canvas>' +
      '<div class="co__row" style="margin-top:.7rem"><button class="co__btn co__btn--primary" data-dl>Download image</button></div>' +
      '<label class="co__field" style="margin-top:1rem"><span>Caption (edit it to sound like you)</span><textarea class="co__textarea" rows="9" data-cap>' + esc(shareCaption(c)) + '</textarea></label>' +
      '<button class="co__btn" data-copycap>Copy caption</button>' +
      '<p class="co__small" style="margin-top:.6rem">Post it as one image with the caption. Your link: <b>' + esc(c.product_url) + '</b></p></div>';
    render(h); bindBack();
    var cv = mount.querySelector('canvas');
    var paint = function () { drawShareImage(cv, c); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(paint); else paint();
    paint();
    mount.querySelector('[data-dl]').addEventListener('click', function () {
      try { if (window.HubTrack) window.HubTrack('coach_share_kit', { coach: c.slug, step: 'download' }); } catch (x) { /* */ }
      cv.toBlob(function (b) {
        var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'athlo-coaching-' + c.slug + '.png';
        document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1500);
      }, 'image/png');
    });
    mount.querySelector('[data-copycap]').addEventListener('click', function () {
      var t = mount.querySelector('[data-cap]').value;
      (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { toast('Caption copied'); },
        function () { mount.querySelector('[data-cap]').select(); toast('Select all and copy'); });
    });
  }

  // ── Phase 4 (2026-11-05): who is drifting, progress, templates ──
  function riskText(r) {
    return r.reason === 'quiet' ? 'Gone quiet · no log for ' + r.days + ' days' : 'Skipping · ' + r.done + ' of ' + r.due + ' done (last 2 weeks)';
  }
  function drawProgress(pane) {
    var j = state.current, a = j.athlete, ser = j.series || [];
    var h = '<div class="co__card">' + (j.risk ? '<p class="co__note"><b>' + esc(riskText(j.risk)) + '.</b> A short message usually brings them back.</p>' : '');
    if (!ser.length) { pane.innerHTML = h + '<div class="co__empty">Progress shows up once their plan is running.</div></div>'; return; }
    var max = Math.max.apply(null, ser.map(function (w) { return Math.max(w.planned, w.done + w.extra); }).concat([1]));
    h += '<p class="co__label">Week by week</p><div class="co__bars" role="list">' + ser.map(function (w) {
      var pct = w.planned ? Math.round(w.done / w.planned * 100) : null;
      return '<div class="co__bar" role="listitem"><span class="co__bar-wk">' + esc(fmtDay(w.monday, { day: 'numeric', month: 'short' })) + '</span>' +
        '<span class="co__bar-track"><span class="co__bar-plan" style="width:' + (w.planned / max * 100) + '%"></span>' +
        '<span class="co__bar-done" style="width:' + ((w.done + w.extra) / max * 100) + '%"></span></span>' +
        '<span class="co__bar-num">' + w.done + '/' + w.planned + (w.extra ? ' +' + w.extra : '') + (pct !== null ? ' · ' + pct + '%' : '') +
        (w.avg_rpe ? ' · effort ' + w.avg_rpe : '') + '</span></div>';
    }).join('') + '</div><p class="co__small">Grey: planned. Green: done (+ extra sessions they added).</p></div>';
    pane.innerHTML = h;
  }
  function bindTemplates(pane, a) {
    var slot = pane.querySelector('[data-tpl-slot]');
    var save = pane.querySelector('[data-tpl-save]'), use = pane.querySelector('[data-tpl-use]');
    if (save) save.addEventListener('click', function () {
      slot.innerHTML = '<form class="co__session" style="margin-top:.6rem" data-tpl-form novalidate>' +
        '<label class="co__field"><span>Template name</span><input class="co__input" name="name" maxlength="60" placeholder="e.g. 10 km base week"></label>' +
        '<label class="co__field"><span>How many weeks, starting this week</span><select class="co__input" name="weeks"><option value="1">1 week</option><option value="2">2 weeks</option><option value="4">4 weeks</option></select></label>' +
        '<div class="co__row"><button class="co__btn co__btn--primary" type="submit">Save template</button><button class="co__btn co__btn--ghost" type="button" data-tpl-cancel>Cancel</button></div>' +
        '<p class="co__small">Saved with each session\'s target and notes. Use it on any athlete, any week.</p><p class="co__err" hidden></p></form>';
      var f = slot.querySelector('form'); f.name.focus();
      f.querySelector('[data-tpl-cancel]').addEventListener('click', function () { slot.innerHTML = ''; });
      f.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var btn = f.querySelector('[type=submit]'); btn.disabled = true;
        post({ action: 'coach-template-save', enrolment_id: a.id, name: f.name.value, from_monday: state.weekStart, weeks: Number(f.weeks.value) }).then(function (r) {
          btn.disabled = false;
          if (!r.ok) { var e = f.querySelector('.co__err'); e.textContent = r.error === 'nothing_to_save' ? 'There are no sessions in those weeks to save.' : errText(r); e.hidden = false; return; }
          slot.innerHTML = ''; toast('Saved "' + r.name + '" (' + r.sessions + ' sessions)');
        });
      });
    });
    if (use) use.addEventListener('click', function () {
      slot.innerHTML = '<p class="co__small">Loading your templates...</p>';
      post({ action: 'coach-template-list' }).then(function (r) {
        if (!r.ok) { slot.innerHTML = ''; return toast(errText(r), true); }
        if (!r.templates.length) { slot.innerHTML = '<p class="co__small" style="margin-top:.6rem">No templates yet. Plan a week, then press "Save as a template".</p>'; return; }
        slot.innerHTML = '<form class="co__session" style="margin-top:.6rem" data-tpl-apply novalidate>' +
          '<label class="co__field"><span>Template</span><select class="co__input" name="tpl">' + r.templates.map(function (t) {
            return '<option value="' + esc(t.id) + '">' + esc(t.name) + ' · ' + t.weeks + ' wk · ' + t.sessions + ' sessions</option>'; }).join('') + '</select></label>' +
          '<p class="co__small">It goes onto the week of <b>' + esc(fmtDay(state.weekStart, { day: 'numeric', month: 'short' })) + '</b>. Use the arrows above to pick another week first.</p>' +
          '<div class="co__row"><button class="co__btn co__btn--primary" type="submit">Add to this week</button><button class="co__btn co__btn--ghost" type="button" data-tpl-del>Delete template</button>' +
          '<button class="co__btn co__btn--ghost" type="button" data-tpl-cancel>Cancel</button></div><p class="co__err" hidden></p></form>';
        var f = slot.querySelector('form');
        f.querySelector('[data-tpl-cancel]').addEventListener('click', function () { slot.innerHTML = ''; });
        f.querySelector('[data-tpl-del]').addEventListener('click', function () {
          if (!confirm('Delete this template? Plans already made from it are not affected.')) return;
          post({ action: 'coach-template-delete', template_id: f.tpl.value }).then(function (x) {
            if (!x.ok) return toast(errText(x), true);
            toast('Template deleted'); slot.innerHTML = '';
          });
        });
        function apply(force) {
          var btn = f.querySelector('[type=submit]'); btn.disabled = true;
          post({ action: 'coach-template-apply', enrolment_id: a.id, template_id: f.tpl.value, to_monday: state.weekStart, force: !!force }).then(function (x) {
            btn.disabled = false;
            if (!x.ok && x.error === 'week_not_empty') {
              if (confirm('Those weeks already have ' + x.existing + ' session(s). Replace them? Sessions the athlete already logged are kept.')) apply(true);
              return;
            }
            if (!x.ok) { var e = f.querySelector('.co__err'); e.textContent = errText(x); e.hidden = false; return; }
            toast(x.added + ' sessions added'); refresh();
          });
        }
        f.addEventListener('submit', function (ev) { ev.preventDefault(); apply(false); });
      });
    });
  }
  function lateText(h) { return h >= 48 ? Math.floor(h / 24) + ' days' : h + ' hours'; }
  var LATE = { offer_times: 'is waiting for you to offer intro-call times', write_plan: 'is waiting for their plan', reply: 'is waiting for your feedback' };
  function banner(a) {
    var late = a.overdue ? '<p class="co__note"><b>Overdue:</b> ' + esc(a.name.split(' ')[0]) + ' ' + (LATE[a.overdue.reason] || 'is waiting on you') +
      ' (' + lateText(a.overdue.hours) + '). We have sent you a reminder; after a little longer the ATHLO+ team steps in.</p>' : '';
    return late + bannerBody(a);
  }
  function bannerBody(a) {
    if (a.step === 'awaiting_slots') return '<button class="co__btn co__btn--primary co__btn--block" data-goto="call">Offer times for the intro call</button>';
    if (a.step === 'awaiting_plan') {
      var why = a.call_at ? 'Intro call: <b>' + esc(fmtWhen(a.call_at)) + '</b>. ' : '';
      return '<p class="co__p">' + why + 'Write their plan below, then press <b>Send plan</b>.</p>' +
        (a.intake ? '<button class="co__btn co__btn--sm" data-goto="about">Read their intake first</button>' : '');
    }
    if (a.step === 'choose_start' || a.step === 'intake') return '<p class="co__p co__small">You can start drafting their plan now. They only see it once you send it.</p>';
    return '';
  }

  // ----- Plan tab -----
  function planTools(a) {
    // Week / Month switch, plus the spreadsheet in and out (2026-11-04).
    var h = '<div class="co__toolbar"><div class="co__seg" role="group" aria-label="Plan view">' +
      '<button type="button" class="co__seg-btn" data-view="week" aria-pressed="' + (state.planView === 'week') + '">Week</button>' +
      '<button type="button" class="co__seg-btn" data-view="month" aria-pressed="' + (state.planView === 'month') + '">Month</button></div>';
    if (a.writable) h += '<div class="co__row co__toolbar-actions">' +
      '<button type="button" class="co__btn co__btn--sm" data-import>Paste from a spreadsheet</button>' +
      (state.current.sessions.length ? '<button type="button" class="co__btn co__btn--sm" data-export>Copy plan to a spreadsheet</button>' : '') + '</div>';
    return h + '</div>';
  }
  function bindPlanTools(pane) {
    pane.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        state.planView = b.getAttribute('data-view');
        if (state.planView === 'month') state.monthStart = state.weekStart.slice(0, 8) + '01';
        drawPlan(pane);
      });
    });
    var imp = pane.querySelector('[data-import]');
    if (imp) imp.addEventListener('click', function () { state.paste = { text: '', mode: 'add', preview: null }; drawPaste(pane); });
    var exp = pane.querySelector('[data-export]');
    if (exp) exp.addEventListener('click', function () { copyText(state.current.plan_tsv || '', 'Plan copied. Paste it into Excel or Google Sheets.'); });
  }
  function copyText(text, msg) {
    var done = function () { toast(msg); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { fallbackCopy(text, done); });
    } else fallbackCopy(text, done);
  }
  function fallbackCopy(text, done) {
    var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0'; document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); done(); } catch (e) { toast('Could not copy. Select the plan and copy it by hand.'); }
    ta.remove();
  }

  function drawPlan(pane) {
    var j = state.current, a = j.athlete;
    if (state.planView === 'month') return drawMonth(pane);
    var ws = state.weekStart, we = addDays(ws, 6);
    var week = j.sessions.filter(function (s) { return s.day >= ws && s.day <= we; });
    var logsBySession = {};
    j.logs.forEach(function (l) { if (l.session_id) (logsBySession[l.session_id] = logsBySession[l.session_id] || []).push(l); });

    var h = planTools(a) + '<div class="co__card"><div class="co__weekbar">' +
      '<button class="co__btn co__btn--icon co__btn--sm" data-week="-7" aria-label="Previous week">&lsaquo;</button>' +
      '<b>Week of ' + esc(fmtDay(ws, { day: 'numeric', month: 'short' })) + '</b>' +
      '<button class="co__btn co__btn--icon co__btn--sm" data-week="7" aria-label="Next week">&rsaquo;</button></div>';
    for (var i = 0; i < 7; i++) {
      var day = addDays(ws, i);
      var items = week.filter(function (s) { return s.day === day; });
      h += '<div class="co__day' + (day === j.today ? ' co__day--today' : '') + '">' +
        '<div class="co__day-head"><span class="co__day-name">' + esc(fmtDay(day, { weekday: 'long' })) +
        '<small>' + esc(fmtDay(day, { day: 'numeric', month: 'short' })) + '</small></span>' +
        (a.writable ? '<button class="co__btn co__btn--sm" data-add="' + day + '">+ Add</button>' : '') + '</div>';
      if (!items.length) h += '<div class="co__day-rest">' + (a.plan_published_at ? 'Rest' : 'Nothing planned') + '</div>';
      items.forEach(function (s) {
        var done = logsBySession[s.id];
        h += '<div class="co__session' + (done ? ' co__session--done' : '') + '" data-sess="' + esc(s.id) + '">' +
          '<div class="co__row co__row--between"><span class="co__session-title">' + esc(s.title) + '</span>' +
          (done ? '<span class="co__chip co__chip--go">Logged</span>' : (a.plan_published_at && s.day < j.today ? '<span class="co__chip co__chip--miss">Missed</span>' : '')) + '</div>' +
          (s.target ? '<div class="co__session-target">' + esc(s.target) + '</div>' : '') +
          (s.detail ? '<div class="co__session-detail">' + esc(s.detail) + '</div>' : '') +
          (a.writable ? '<div class="co__row co__session-actions"><button class="co__btn co__btn--sm" data-edit="' + esc(s.id) + '">Edit</button>' +
            '<button class="co__btn co__btn--sm co__btn--danger" data-del="' + esc(s.id) + '">Delete</button></div>' : '') +
          '</div>';
      });
      h += '<div data-form-slot="' + day + '"></div></div>';
    }
    h += '</div>';
    if (a.writable) {
      h += '<div class="co__card co__stack">' +
        '<button class="co__btn co__btn--block" data-copy>Copy this week to next week</button>' +
        '<div class="co__row"><button class="co__btn co__btn--sm" data-tpl-save>Save as a template</button>' +
        '<button class="co__btn co__btn--sm" data-tpl-use>Use a template</button></div><div data-tpl-slot></div>' +
        '<button class="co__btn co__btn--primary co__btn--lg co__btn--block" data-publish>' + (a.plan_published_at ? 'Send update to ' + esc(a.name.split(' ')[0]) : 'Send plan to ' + esc(a.name.split(' ')[0])) + '</button>' +
        '<p class="co__small">' + (a.plan_published_at ? 'They already see every change you make. Sending an update also e-mails them.' : 'Nothing is visible to them until you send it. Sending starts their ' + a.months + '-month block today.') + '</p>' +
        '<p class="co__err" data-plan-err hidden></p></div>';
    }
    pane.innerHTML = h;
    bindPlanTools(pane);

    pane.querySelectorAll('[data-week]').forEach(function (b) {
      b.addEventListener('click', function () { state.weekStart = addDays(state.weekStart, Number(b.getAttribute('data-week'))); drawPlan(pane); });
    });
    pane.querySelectorAll('[data-add]').forEach(function (b) {
      b.addEventListener('click', function () { sessionForm(pane, b.getAttribute('data-add'), null); });
    });
    pane.querySelectorAll('[data-edit]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = j.sessions.filter(function (x) { return x.id === b.getAttribute('data-edit'); })[0];
        if (s) sessionForm(pane, s.day, s);
      });
    });
    pane.querySelectorAll('[data-del]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!confirm('Delete this session?')) return;
        b.disabled = true;
        post({ action: 'coach-session-delete', enrolment_id: a.id, id: b.getAttribute('data-del') }).then(function (r) {
          if (!r.ok) { b.disabled = false; return toast(errText(r), true); }
          refresh();
        });
      });
    });
    bindTemplates(pane, a);
    var copy = pane.querySelector('[data-copy]');
    var copyWeek = function (force) {
      copy.disabled = true;
      post({ action: 'coach-copy-week', enrolment_id: a.id, from_monday: state.weekStart, force: !!force }).then(function (r) {
        copy.disabled = false;
        if (!r.ok && r.error === 'next_week_not_empty') {
          if (confirm('Next week already has sessions. Replace them with this week\'s? Anything ' + a.name.split(' ')[0] + ' already logged is kept.')) copyWeek(true);
          return;
        }
        if (!r.ok) return planErr(pane, errText(r));
        toast(r.copied + ' session' + (r.copied > 1 ? 's' : '') + ' copied');
        state.weekStart = addDays(state.weekStart, 7);
        refresh();
      });
    };
    if (copy) copy.addEventListener('click', function () { copyWeek(false); });
    var pub = pane.querySelector('[data-publish]');
    if (pub) pub.addEventListener('click', function () {
      // Sending starts their month and replaces the "your call is booked" screen they see, so check first
      // when an intro call is still to come (or was asked for and never booked).
      if (!a.plan_published_at && a.start_mode === 'call' && (!a.call_at || Date.parse(a.call_at) > Date.now())) {
        var first = a.name.split(' ')[0];
        if (!confirm(a.call_at ? 'Your intro call with ' + first + ' has not happened yet. Send the plan now anyway? Their month starts today.'
          : first + ' asked for an intro call and has not booked one. Send the plan now anyway? Their month starts today.')) return;
      }
      pub.disabled = true;
      post({ action: 'coach-publish', enrolment_id: a.id }).then(function (r) {
        pub.disabled = false;
        if (!r.ok) return planErr(pane, errText(r));
        toast(r.first ? 'Plan sent' : 'Update sent');
        refresh();
      });
    });
  }
  function planErr(pane, msg) { var e = pane.querySelector('[data-plan-err]'); if (e) { e.textContent = msg; e.hidden = false; } }

  // ----- Month view: the whole month at a glance; tap a day to open its week -----
  function drawMonth(pane) {
    var j = state.current, a = j.athlete;
    var ms = state.monthStart || state.weekStart.slice(0, 8) + '01';
    pane.innerHTML = planTools(a) + monthGrid(ms, j.sessions, j.logs, j.today, true);
    bindPlanTools(pane);
    pane.querySelectorAll('[data-month]').forEach(function (b) {
      b.addEventListener('click', function () { state.monthStart = shiftMonth(ms, Number(b.getAttribute('data-month'))); drawMonth(pane); });
    });
    pane.querySelectorAll('[data-day]').forEach(function (b) {
      b.addEventListener('click', function () { state.weekStart = mondayOf(b.getAttribute('data-day')); state.planView = 'week'; drawPlan(pane); });
    });
  }
  function shiftMonth(ms, n) { var d = new Date(ms + 'T00:00:00Z'); d.setUTCMonth(d.getUTCMonth() + n, 1); return d.toISOString().slice(0, 10); }
  function monthGrid(ms, sessions, logs, today, coachSide) {
    var next = shiftMonth(ms, 1), start = mondayOf(ms), end = addDays(mondayOf(addDays(next, -1)), 6);
    var byDay = {}, done = {};
    sessions.forEach(function (s) { if (s.day >= start && s.day <= end) (byDay[s.day] = byDay[s.day] || []).push(s); });
    logs.forEach(function (l) { if (l.session_id) done[l.session_id] = true; });
    var total = sessions.filter(function (s) { return s.day >= ms && s.day < next; }).length;
    var h = '<div class="co__card"><div class="co__weekbar">' +
      '<button class="co__btn co__btn--icon co__btn--sm" data-month="-1" aria-label="Previous month">&lsaquo;</button>' +
      '<b>' + esc(new Date(ms + 'T00:00:00Z').toLocaleDateString('en-SG', { timeZone: 'UTC', month: 'long', year: 'numeric' })) +
      ' <small class="co__muted">' + total + ' session' + (total === 1 ? '' : 's') + '</small></b>' +
      '<button class="co__btn co__btn--icon co__btn--sm" data-month="1" aria-label="Next month">&rsaquo;</button></div>' +
      '<div class="co__month" role="grid">' + ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(function (d) { return '<span class="co__month-dow">' + d + '</span>'; }).join('');
    for (var day = start; day <= end; day = addDays(day, 1)) {
      var items = byDay[day] || [], out = day < ms || day >= next;
      h += '<button type="button" class="co__mday' + (out ? ' co__mday--out' : '') + (day === today ? ' co__mday--today' : '') + (items.length ? ' co__mday--has' : '') +
        '" data-day="' + day + '" aria-label="' + esc(fmtDay(day, { weekday: 'long', day: 'numeric', month: 'long' })) + ': ' +
        (items.length ? esc(items.map(function (s) { return s.title + (done[s.id] ? ' (logged)' : ''); }).join(', ')) : 'rest') + '">' +
        '<span class="co__mday-n">' + Number(day.slice(8)) + '</span>' +
        items.slice(0, 3).map(function (s) {
          return '<span class="co__mday-s' + (done[s.id] ? ' co__mday-s--done' : '') + '">' + esc(s.title) + '</span>';
        }).join('') + (items.length > 3 ? '<span class="co__mday-more">+' + (items.length - 3) + '</span>' : '') + '</button>';
    }
    return h + '</div><p class="co__small" style="margin-top:.6rem">Tap a day to open that week' + (coachSide ? ' and edit it' : '') + '.</p></div>';
  }

  // ----- Paste a plan from Excel / Google Sheets / a Word table -----
  var PASTE_ERR = {
    bad_date: 'could not read the date', missing_title: 'no session name', out_of_range: 'date is too far back or too far ahead',
    too_many_rows: 'only the first 200 rows are read', empty: 'nothing was pasted'
  };
  var TEMPLATE = 'Date\tSession\tTarget\tNotes\n' +
    '5/11/2026\tIntervals\t6 x 800 m @ 3:45/km, 90 s jog\t15 min easy warm-up. Log each split.\n' +
    '6/11/2026\tRest\t\t\n' +
    '7/11/2026\tLong run\t18 km easy, last 3 km at marathon pace\tTake a gel at 10 km.';
  function drawPaste(pane) {
    var P = state.paste, a = state.current.athlete;
    var h = '<button type="button" class="co__btn co__btn--ghost co__btn--sm" data-paste-back>&larr; Back to the plan</button>' +
      '<div class="co__card" style="margin-top:.6rem"><p class="co__label">Paste a plan</p>' +
      '<h2 class="co__h2">From Excel, Google Sheets or a Word table</h2>' +
      '<p class="co__p">Select the rows in your sheet, copy, and paste them here. Use four columns: ' +
      '<b>Date · Session · Target · Notes</b>. A header row is optional. A day with <b>Rest</b> (or nothing) stays empty.</p>' +
      '<button type="button" class="co__btn co__btn--sm" data-template>Copy a blank template</button>' +
      '<label class="co__field" style="margin-top:.9rem"><span>Your rows</span>' +
      '<textarea class="co__textarea co__paste" name="paste" spellcheck="false" placeholder="Date&#9;Session&#9;Target&#9;Notes&#10;5/11/2026&#9;Intervals&#9;6 x 800 m&#9;Warm up first">' + esc(P.text) + '</textarea>' +
      '<small>Dates like 5/11/2026, 5 Nov or Thu 5 Nov all work (day first).</small></label>' +
      '<fieldset class="co__radios"><legend class="co__label">If a day already has sessions</legend>' +
      '<label><input type="radio" name="mode" value="add"' + (P.mode === 'add' ? ' checked' : '') + '> <span><b>Add</b> these alongside them</span></label>' +
      '<label><input type="radio" name="mode" value="replace"' + (P.mode === 'replace' ? ' checked' : '') + '> <span><b>Replace</b> them with these <small>(anything ' + esc(a.name.split(' ')[0]) + ' has already logged is kept)</small></span></label></fieldset>' +
      '<button type="button" class="co__btn co__btn--primary co__btn--block" data-preview>Preview</button>' +
      '<p class="co__err" data-paste-err hidden></p></div><div data-paste-preview></div>';
    pane.innerHTML = h;
    var ta = pane.querySelector('[name=paste]');
    ta.addEventListener('input', function () { P.text = ta.value; P.preview = null; pane.querySelector('[data-paste-preview]').innerHTML = ''; });
    pane.querySelectorAll('[name=mode]').forEach(function (r) {
      r.addEventListener('change', function () { P.mode = r.value; if (P.preview) preview(pane); });
    });
    pane.querySelector('[data-paste-back]').addEventListener('click', function () { state.paste = null; drawPlan(pane); });
    pane.querySelector('[data-template]').addEventListener('click', function () { copyText(TEMPLATE, 'Template copied. Paste it into a new sheet.'); });
    pane.querySelector('[data-preview]').addEventListener('click', function () { preview(pane); });
    if (P.preview) showPreview(pane, P.preview);
  }
  function preview(pane) {
    var P = state.paste, err = pane.querySelector('[data-paste-err]'), btn = pane.querySelector('[data-preview]');
    err.hidden = true;
    if (!P.text.trim()) { err.textContent = 'Paste your rows first.'; err.hidden = false; return; }
    btn.disabled = true;
    post({ action: 'coach-import', enrolment_id: state.current.athlete.id, text: P.text, mode: P.mode, dry_run: true }).then(function (r) {
      btn.disabled = false;
      if (!r.sessions) { err.textContent = errText(r); err.hidden = false; return; }
      P.preview = r; showPreview(pane, r);
    });
  }
  function showPreview(pane, r) {
    var P = state.paste, box = pane.querySelector('[data-paste-preview]');
    var n = r.sessions.length, weeks = {};
    r.sessions.forEach(function (s) { (weeks[mondayOf(s.day)] = weeks[mondayOf(s.day)] || []).push(s); });
    var first = n ? r.sessions[0].day : null, last = n ? r.sessions[n - 1].day : null;
    var h = '<div class="co__card"><p class="co__label">Preview</p>';
    if (n) h += '<h2 class="co__h2">' + n + ' session' + (n > 1 ? 's' : '') + ' · ' + esc(fmtDay(first, { day: 'numeric', month: 'short' })) +
      (last !== first ? ' to ' + esc(fmtDay(last, { day: 'numeric', month: 'short' })) : '') + '</h2>';
    else h += '<h2 class="co__h2">No sessions found</h2>';
    var notes = [];
    if (r.rest_days.length) notes.push(r.rest_days.length + ' rest day' + (r.rest_days.length > 1 ? 's' : ''));
    if (r.existing_on_days) notes.push(r.mode === 'replace'
      ? r.will_remove + ' existing session' + (r.will_remove === 1 ? '' : 's') + ' on these days will be replaced' + (r.kept_logged ? ', ' + r.kept_logged + ' already logged kept' : '')
      : r.existing_on_days + ' session' + (r.existing_on_days === 1 ? '' : 's') + ' already on these days will stay');
    if (notes.length) h += '<p class="co__p co__small">' + esc(notes.join(' · ')) + '</p>';
    if (r.errors.length) {
      h += '<div class="co__paste-errs"><p class="co__p"><b>' + r.errors.length + ' row' + (r.errors.length > 1 ? 's' : '') + ' skipped</b>. Fix them in your sheet and paste again, or carry on without them:</p><ul>' +
        r.errors.slice(0, 12).map(function (e) {
          return '<li>Row ' + e.line + ': ' + esc(PASTE_ERR[e.error] || e.error) + (e.text ? ' <span class="co__raw">' + esc(e.text) + '</span>' : '') + '</li>';
        }).join('') + (r.errors.length > 12 ? '<li>and ' + (r.errors.length - 12) + ' more</li>' : '') + '</ul></div>';
    }
    Object.keys(weeks).sort().forEach(function (wk) {
      h += '<div class="co__pv-week"><p class="co__label">Week of ' + esc(fmtDay(wk, { day: 'numeric', month: 'short' })) + '</p>';
      weeks[wk].forEach(function (s) {
        h += '<div class="co__pv-row"><span class="co__pv-day">' + esc(fmtDay(s.day, { weekday: 'short', day: 'numeric', month: 'short' })) + '</span>' +
          '<span class="co__pv-main"><b>' + esc(s.title) + '</b>' + (s.target ? '<span class="co__session-target">' + esc(s.target) + '</span>' : '') +
          (s.detail ? '<span class="co__session-detail">' + esc(s.detail) + '</span>' : '') + '</span></div>';
      });
      h += '</div>';
    });
    if (n || r.will_remove) {
      h += '<button type="button" class="co__btn co__btn--primary co__btn--lg co__btn--block" data-commit style="margin-top:.9rem">' +
        (n ? 'Add ' + n + ' session' + (n > 1 ? 's' : '') + ' to the plan' : 'Clear those days') + '</button>' +
        '<p class="co__small">' + (state.current.athlete.plan_published_at
          ? 'They see changes straight away. Press Send update afterwards to e-mail them.'
          : 'Nothing is visible to them until you press Send plan.') + ' Every session can still be edited or deleted one by one.</p>';
    }
    box.innerHTML = h + '<p class="co__err" data-commit-err hidden></p></div>';
    var c = box.querySelector('[data-commit]');
    if (c) c.addEventListener('click', function () {
      c.disabled = true;
      post({ action: 'coach-import', enrolment_id: state.current.athlete.id, text: P.text, mode: P.mode }).then(function (res) {
        c.disabled = false;
        if (!res.ok) { var e = box.querySelector('[data-commit-err]'); e.textContent = errText(res); e.hidden = false; return; }
        toast(res.imported + ' session' + (res.imported === 1 ? '' : 's') + ' added' + (res.removed ? ', ' + res.removed + ' replaced' : ''));
        state.paste = null; state.planView = 'week';
        if (res.first_day) state.weekStart = mondayOf(res.first_day);
        refresh();
      });
    });
  }

  function sessionForm(pane, day, s) {
    pane.querySelectorAll('[data-form-slot]').forEach(function (x) { x.innerHTML = ''; });
    var slot = pane.querySelector('[data-form-slot="' + day + '"]');
    if (!slot) return;
    slot.innerHTML = '<form class="co__session" style="margin-top:.5rem" novalidate>' +
      '<label class="co__field"><span>Session</span><input class="co__input" name="title" maxlength="120" required placeholder="e.g. Easy run, Intervals, Long run" value="' + esc(s ? s.title : '') + '"></label>' +
      '<label class="co__field"><span>Target</span><input class="co__input" name="target" maxlength="200" placeholder="e.g. 6 x 800 m @ 3:45/km, 90 s jog" value="' + esc(s ? s.target || '' : '') + '"></label>' +
      '<label class="co__field"><span>Notes for the athlete</span><textarea class="co__textarea" name="detail" maxlength="2000" placeholder="Warm-up, cues, what to log">' + esc(s ? s.detail || '' : '') + '</textarea></label>' +
      '<label class="co__field"><span>Day</span><input class="co__input" type="date" name="day" value="' + esc(day) + '"></label>' +
      '<div class="co__row"><button class="co__btn co__btn--primary" type="submit">' + (s ? 'Save' : 'Add session') + '</button>' +
      '<button class="co__btn co__btn--ghost" type="button" data-cancel>Cancel</button></div><p class="co__err" hidden></p></form>';
    var f = slot.querySelector('form');
    f.querySelector('[name=title]').focus();
    f.querySelector('[data-cancel]').addEventListener('click', function () { slot.innerHTML = ''; });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var btn = f.querySelector('[type=submit]'); btn.disabled = true;
      var body = { action: 'coach-session', enrolment_id: state.current.athlete.id, day: f.day.value, title: f.title.value, target: f.target.value, detail: f.detail.value };
      if (s) body.id = s.id;
      post(body).then(function (r) {
        btn.disabled = false;
        if (!r.ok) { var e = f.querySelector('.co__err'); e.textContent = errText(r); e.hidden = false; return; }
        refresh();
      });
    });
  }

  // ----- Logs + chat tab -----
  function drawChat(pane) {
    var j = state.current, a = j.athlete;
    var sessById = {}; j.sessions.forEach(function (s) { sessById[s.id] = s; });
    var replies = {}; var general = [];
    j.messages.forEach(function (m) { if (m.log_id) (replies[m.log_id] = replies[m.log_id] || []).push(m); else general.push(m); });
    var filesBy = {}; (j.attachments || []).forEach(function (f) { var k = f.log_id || f.message_id; (filesBy[k] = filesBy[k] || []).push(f); });
    // One timeline, oldest first: logs (with their review and replies) and loose messages.
    var items = j.logs.map(function (l) { return { at: l.created_at, log: l }; })
      .concat(general.map(function (m) { return { at: m.created_at, msg: m }; }))
      .sort(function (x, y) { return x.at.localeCompare(y.at); });
    var h = '<div class="co__card">';
    if (!items.length) h += '<div class="co__empty">Nothing yet. When ' + esc(a.name.split(' ')[0]) + ' logs a session or messages you, it shows up here.</div>';
    items.forEach(function (it) {
      if (it.msg) { h += msgHtml(it.msg, filesBy); return; }
      var l = it.log, s = l.session_id && sessById[l.session_id];
      h += '<div class="co__log"><div class="co__log-head"><span>' + esc(s ? s.title : 'Extra session') + ' · ' + esc(fmtDay(l.day)) +
        (l.updated_at ? ' · <i>edited</i>' : '') + '</span>' + (l.rpe ? '<span>Effort ' + l.rpe + '/10</span>' : '') + '</div>' +
        (l.result ? '<div class="co__log-result">' + esc(l.result) + '</div>' : '') +
        (l.notes ? '<div class="co__log-notes">' + esc(l.notes) + '</div>' : '') +
        filesHtml(filesBy[l.id]) + reviewBadge(l, j.review) +
        (replies[l.id] || []).map(function (m) { return msgHtml(m, filesBy); }).join('') +
        (a.writable ? '<button class="co__btn co__btn--sm' + (l.reviewed_at ? '' : ' co__btn--primary') + '" style="margin-top:.5rem" data-review="' + esc(l.id) + '">' +
          (l.reviewed_at ? 'Reply again' : 'Review') + '</button><div data-review-slot="' + esc(l.id) + '"></div>' : '') +
        '</div>';
    });
    if (a.writable) h += composer('Message ' + a.name.split(' ')[0]);
    h += '</div>';
    pane.innerHTML = h;
    bindComposer(pane.querySelector('[data-composer]'), null);
    pane.querySelectorAll('[data-review]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-review'), slot = pane.querySelector('[data-review-slot="' + id + '"]');
        var log = j.logs.filter(function (x) { return x.id === id; })[0];
        slot.innerHTML = reviewForm(log, j.review);
        b.hidden = true;
        bindReview(slot.querySelector('form'), log);
      });
    });
    var last = pane.querySelector('.co__card'); if (last && items.length) last.lastElementChild.scrollIntoView({ block: 'nearest' });
  }
  function reviewBadge(l, R) {
    if (!l.reviewed_at || (!l.coach_verdict && !(l.coach_focus || []).length)) return '';
    var v = (R.verdicts.filter(function (x) { return x.key === l.coach_verdict; })[0] || {}).label;
    var f = (l.coach_focus || []).map(function (k) { return (R.focus.filter(function (x) { return x.key === k; })[0] || {}).label || k; });
    return '<div class="co__review">' + (v ? '<span class="co__chip co__chip--go">' + esc(v) + '</span>' : '') +
      (f.length ? '<span class="co__review-focus">Focus: ' + esc(f.join(', ')) + '</span>' : '') + '</div>';
  }
  function reviewForm(l, R) {
    var h = '<form class="co__reviewform" novalidate><p class="co__label">How did it go?</p><div class="co__chips" role="group" aria-label="Verdict">' +
      R.verdicts.map(function (v) { return '<button type="button" class="co__pick" data-verdict="' + v.key + '" aria-pressed="' + (l.coach_verdict === v.key) + '">' + esc(v.label) + '</button>'; }).join('') +
      '</div><p class="co__label" style="margin-top:.7rem">Focus on (up to 3)</p><div class="co__chips" role="group" aria-label="Focus areas">' +
      R.focus.map(function (f) { return '<button type="button" class="co__pick" data-focus="' + f.key + '" aria-pressed="' + ((l.coach_focus || []).indexOf(f.key) >= 0) + '">' + esc(f.label) + '</button>'; }).join('') +
      '</div><label class="co__field" style="margin-top:.7rem"><span>Your feedback (optional)</span><textarea class="co__textarea" name="text" maxlength="2000" placeholder="What went well, what to change next time"></textarea></label>' +
      filePicker() + '<div class="co__row" style="margin-top:.6rem"><button class="co__btn co__btn--primary" type="submit">Send review</button>' +
      '<button class="co__btn co__btn--ghost" type="button" data-cancel>Cancel</button></div><p class="co__err" hidden></p></form>';
    return h;
  }
  function bindReview(f, l) {
    var pick = bindPicker(f);
    f.querySelectorAll('[data-verdict]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        f.querySelectorAll('[data-verdict]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', String(on));
      });
    });
    f.querySelectorAll('[data-focus]').forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        if (on && f.querySelectorAll('[data-focus][aria-pressed="true"]').length >= 3) return toast(ERR.focus_max_3);
        b.setAttribute('aria-pressed', String(on));
      });
    });
    f.querySelector('[data-cancel]').addEventListener('click', function () { refresh(); });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var err = f.querySelector('.co__err'), btn = f.querySelector('[type=submit]');
      var verdict = (f.querySelector('[data-verdict][aria-pressed="true"]') || { getAttribute: function () { return null; } }).getAttribute('data-verdict');
      var focus = [].map.call(f.querySelectorAll('[data-focus][aria-pressed="true"]'), function (b) { return b.getAttribute('data-focus'); });
      btn.disabled = true; btn.textContent = 'Sending...';
      uploadAll(pick()).then(function (up) {
        if (up.error) return { ok: false, error: up.error };
        return post({ action: 'coach-review', enrolment_id: state.current.athlete.id, log_id: l.id, verdict: verdict, focus: focus, text: f.text.value, files: up.files });
      }).then(function (r) {
        btn.disabled = false; btn.textContent = 'Send review';
        if (!r.ok) { err.textContent = errText(r); err.hidden = false; return; }
        toast('Review sent'); refresh();
      });
    });
  }
  function msgHtml(m, filesBy) {
    var me = m.author === 'coach';
    return '<div class="co__msg co__msg--' + (me ? 'me' : 'them') + '">' + (m.body ? esc(m.body) : '') + filesHtml(filesBy && filesBy[m.id]) +
      '<small>' + (me ? 'You' : esc(state.current.athlete.name.split(' ')[0])) + ' · ' + esc(ago(m.created_at)) + '</small></div>';
  }
  function composer(ph) {
    return '<form class="co__composer co__composer--files" data-composer><div class="co__composer-row"><textarea class="co__textarea" name="body" maxlength="2000" rows="1" placeholder="' + esc(ph) + '" aria-label="' + esc(ph) + '"></textarea>' +
      '<button class="co__btn co__btn--primary" type="submit">Send</button></div>' + filePicker() + '</form>';
  }
  function bindComposer(f, logId) {
    if (!f) return;
    var ta = f.querySelector('textarea'), pick = bindPicker(f);
    ta.addEventListener('input', function () { ta.style.height = 'auto'; ta.style.height = Math.min(ta.scrollHeight, 200) + 'px'; });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var files = pick();
      if (!ta.value.trim() && !files.length) return;
      var btn = f.querySelector('button[type=submit]'); btn.disabled = true; btn.textContent = files.length ? 'Uploading...' : 'Sending...';
      uploadAll(files).then(function (up) {
        if (up.error) return { ok: false, error: up.error };
        return post({ action: 'coach-message', enrolment_id: state.current.athlete.id, body: ta.value, log_id: logId || undefined, files: up.files });
      }).then(function (r) {
        btn.disabled = false; btn.textContent = 'Send';
        if (!r.ok) { toast(errText(r), true); ta.focus(); return; }
        toast('Sent'); refresh();
      });
    });
  }

  // ----- Intro call tab -----
  function drawCall(pane) {
    var a = state.current.athlete;
    var h = '<div class="co__card">';
    if (a.call_at) h += '<p class="co__label">Booked</p><h2 class="co__h2">' + esc(fmtWhen(a.call_at)) + '</h2>' +
      (a.call_contact ? '<p class="co__p">Their number: <a href="tel:' + esc(a.call_contact.replace(/[^\d+]/g, '')) + '"><b>' + esc(a.call_contact) + '</b></a></p>' : '') +
      (a.call_note ? '<p class="co__p">' + esc(a.call_note) + '</p>' : '') + '<hr style="border:0;border-top:1px solid var(--co-line);margin:1rem 0">';
    else if (a.call_slots.length) h += '<p class="co__p">You offered: <b>' + a.call_slots.map(function (s) { return esc(fmtWhen(s.at)); }).join('</b> or <b>') + '</b>. Waiting for them to pick one.</p>';
    else if (!a.intake) h += '<p class="co__p">' + esc(a.name.split(' ')[0]) + ' would like an intro call and is answering your questions first. You will get their answers by e-mail; then offer times here.</p>';
    else h += '<p class="co__p">' + esc(a.name.split(' ')[0]) + ' would like a 20 to 30 minute intro call. Offer two or three times and they pick one.</p>';
    // Owner 2026-11-05: answers before the call. Times are offered once the answers are in, and the
    // answers sit right here so the coach reads them before (and during) the call.
    if (a.writable && (a.intake || a.call_slots.length || a.call_at)) {
      h += '<form data-slots novalidate><p class="co__label">' + (a.call_slots.length ? 'Offer different times' : 'Times you can do (Singapore time)') + '</p><div class="co__slots">';
      for (var i = 0; i < 3; i++) h += '<input class="co__input" type="datetime-local" name="slot" step="900" aria-label="Time option ' + (i + 1) + '">';
      h += '</div><label class="co__field" style="margin-top:.8rem"><span>How will you call?</span><input class="co__input" name="note" maxlength="300" placeholder="e.g. I will WhatsApp video call you, or a Zoom link" value="' + esc(a.call_note || '') + '"></label>' +
        '<button class="co__btn co__btn--primary co__btn--block" type="submit">Send times</button><p class="co__err" hidden></p></form>';
    }
    if (a.intake) h += '</div><div class="co__card"><p class="co__label">Read before the call: their answers</p>' + qaList(state.current, a);
    pane.innerHTML = h + '</div>';
    var f = pane.querySelector('[data-slots]');
    if (!f) return;
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      // datetime-local has no zone; the coach is entering Singapore time.
      var slots = [].map.call(f.querySelectorAll('[name=slot]'), function (x) { return x.value; })
        .filter(Boolean).map(function (v) { return v + ':00+08:00'; });
      var e = f.querySelector('.co__err');
      if (!slots.length) { e.textContent = 'Pick at least one time.'; e.hidden = false; return; }
      var btn = f.querySelector('[type=submit]'); btn.disabled = true;
      post({ action: 'coach-slots', enrolment_id: a.id, slots: slots, note: f.note.value }).then(function (r) {
        btn.disabled = false;
        if (!r.ok) { e.textContent = errText(r); e.hidden = false; return; }
        toast('Times sent'); refresh();
      });
    });
  }

  function qaList(j, a) {
    return '<dl class="co__qa">' + j.questions.filter(function (q) { return a.intake[q.key]; }).map(function (q) {
      var v = a.intake[q.key]; if (q.type === 'date') v = fmtDay(v, { day: 'numeric', month: 'long', year: 'numeric' });
      if (q.key === 'days') v += ' days a week';
      return '<dt>' + esc(q.label) + '</dt><dd>' + esc(v) + '</dd>';
    }).join('') + '</dl><p class="co__small" style="margin-top:.8rem">Sent ' + esc(ago(a.intake_at)) + '</p>';
  }

  // ----- About tab -----
  function drawAbout(pane) {
    var j = state.current, a = j.athlete;
    var h = '<div class="co__card"><p class="co__label">Intake</p>';
    if (a.intake) h += qaList(j, a);
    else h += '<p class="co__p">They have not filled in the intake yet. You get an e-mail the moment they do.</p>';
    if (a.blocks && a.blocks.length > 1) {
      // Phase 3: every month they bought, so the coach sees how long they have been training together.
      h += '</div><div class="co__card"><p class="co__label">Months with you</p><ol class="co__blocks">' + a.blocks.map(function (k, i) {
        return '<li><b>Month ' + (i + 1) + '</b> ' + (k.starts_on ? esc(fmtDay(k.starts_on, { day: 'numeric', month: 'short' })) + ' to ' + esc(fmtDay(k.ends_on, { day: 'numeric', month: 'short' })) : 'not started yet') +
          ' <span class="co__small">' + esc(k.order_name || '') + (k.status === 'cancelled' ? ' · refunded or cancelled' : '') + '</span></li>';
      }).join('') + '</ol>';
    }
    h += '</div><div class="co__card"><p class="co__label">Order</p><p class="co__p">' + (a.waiver_ok ? '<span class="co__chip co__chip--go">Health terms accepted</span><br>' : '<span class="co__chip">Health terms not yet accepted</span><br>') + esc(a.order_name || '') + ' · ' + a.months + ' month' + (a.months > 1 ? 's' : '') +
      (a.starts_on ? '<br>Block: ' + esc(fmtDay(a.starts_on, { day: 'numeric', month: 'short', year: 'numeric' })) + ' to ' + esc(fmtDay(a.ends_on, { day: 'numeric', month: 'short', year: 'numeric' })) : '<br>Their block starts when you send the plan.') +
      '</p></div>';
    pane.innerHTML = h;
  }

  loadHome();
})();
